import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { MemberActionWidgetsStyled } from "./styled";
import { ROUTE_PATH } from "utils/constants/routePath";
import { Icons } from "components";

const MemberActionWidgets = () => {
  const navigate = useNavigate();
  const { t } = useTranslation(["common"]);

  const handleLogout = () => {
    localStorage.clear();
    sessionStorage.clear();
    window.location.href = "/";
  };

  return (
    <MemberActionWidgetsStyled>
      <div className="logo_user">
        <Icons.MemberPerson3 />
      </div>
      <div className="user_name">{t("My Profile", { ns: "common" })}</div>
      <Icons.DropdownArrow color="#303030" width="10" height="9" />
      <div className="dropdown_menu_list">
        <div
          className="dropdown_item"
          onClick={() => navigate(ROUTE_PATH.HISTORY)}
        >
          <Icons.ProfileHistory />
          {t("History", { ns: "common" })}
        </div>
        <div
          className="dropdown_item"
          onClick={() => navigate(ROUTE_PATH.PROFILE_ME)}
        >
          <Icons.Profile />
          {t("Profile", { ns: "common" })}
        </div>
        <div className="dropdown_item" onClick={handleLogout}>
          <Icons.ProfileLogout />
          {t("Logout", { ns: "common" })}
        </div>
      </div>
    </MemberActionWidgetsStyled>
  );
};

export default MemberActionWidgets;
